import { Box, Stack } from '@mui/material';
import { Link, useLocation } from '@tanstack/react-router';
import { RoutePaths } from 'common-types';
import DefaultAvatar from 'components/drawer/assets/default-avatar.png';
import { isNavLinkActive, pagesData } from 'data/navigation';
import { useGetUserData } from 'hooks/use-get-user-data';
import { FC, memo } from 'react';
import { useStore } from 'store';
import { useShallow } from 'zustand/shallow';

import { profileAvatarSx, tabBarSx, tabIndicatorSx, tabItemSx, wrapperSx } from './styles';

export const BottomTabBar: FC = memo(() => {
  const location = useLocation();
  const { userPhoto } = useGetUserData();
  const { photo } = useStore(useShallow((state) => ({ photo: state.photo })));

  return (
    <Box sx={wrapperSx}>
      <Stack direction="row" alignItems="center" sx={tabBarSx}>
        {pagesData.map((page) => {
          const isActive = isNavLinkActive(location.pathname, page.href);

          return (
            <Box key={page.title} component={Link} to={page.href} sx={tabItemSx}>
              {page.title}
              <Box sx={tabIndicatorSx(isActive)} />
            </Box>
          );
        })}
        <Box component={Link} to={RoutePaths.PROFILE} sx={profileAvatarSx}>
          <Box
            component="img"
            src={photo || userPhoto || DefaultAvatar}
            alt="profile"
            sx={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: 'inherit' }}
          />
        </Box>
      </Stack>
    </Box>
  );
});
